import { useMemo } from 'react';
import { analyzedSessionsIdQuery } from '../../../core/automatic_analysis/queries';
import type { Session } from '../../../core/domain/Session';
import { renderedSessionsIdsQuery } from '../../../core/networkMap/queries';
import { sessionsQuery } from '../../../core/sessions/queries';
import { useAppSelector } from '../../../types';

const useGetSortedSessionsByIaAnalyzed = (): Session[] => {
    const sessions = useAppSelector(sessionsQuery);
    const renderedSessionsIds = useAppSelector(renderedSessionsIdsQuery);
    const analyzedSessionsIds = useAppSelector(analyzedSessionsIdQuery);

    // This needs to be in a separate useMemo to keep newly created objects references as stable as possible.
    const sessionWithAnalysisStatus = useMemo(
        () =>
            sessions.map((session) =>
                analyzedSessionsIds.includes(session.id)
                    ? { ...session, processingIaStatus: 'DONE' as const }
                    : session,
            ),
        [sessions, analyzedSessionsIds],
    );

    const sortedSessions = useMemo(
        () =>
            sessionWithAnalysisStatus
                .filter((session) => renderedSessionsIds.includes(session.id))
                .sort((a, b) => Number(b.processingIaStatus === 'DONE') - Number(a.processingIaStatus === 'DONE')),
        [sessionWithAnalysisStatus, renderedSessionsIds],
    );

    return sortedSessions;
};

export default useGetSortedSessionsByIaAnalyzed;
